export default {
    AMORTIZAVEL: 'Amortizável',
    NAO_AMORTIZAVEL: 'Não Amortizável'
}
